import { render, staticRenderFns } from "./RulesetShuttle.vue?vue&type=template&id=a28a42e6&scoped=true"
import script from "./RulesetShuttle.vue?vue&type=script&lang=js"
export * from "./RulesetShuttle.vue?vue&type=script&lang=js"
import style0 from "./RulesetShuttle.vue?vue&type=style&index=0&id=a28a42e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a42e6",
  null
  
)

export default component.exports